<template>
  <div class="users-detail-order" v-loading="loading">
    <ul class="order-form">
      <li class="form-item">
        <span class="form-item-label">订单数量：</span>
        <div class="form-item-content">
          <span>{{ userData.orderCount || 0 }}</span>
          <span
            class="action"
            @click="
              $router.push({
                path: '/imageOrder',
                query: { userId: $route.params.subId },
              })
            "
          >
            去查看
          </span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">购买商品数量：</span>
        <div class="form-item-content">
          {{ userData.photoCount || 0 }}
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">消费总金额：</span>
        <div class="form-item-content">{{ userData.allPrice || 0 }} 元</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { findUserStatisticsByCreator2 } from "@/api/req";
export default {
  name: "userDetailOrder",
  data() {
    return {
      userData: {},
      loading: true,
    };
  },
  computed: {
    userId() {
      return this.$route.params.id;
    },
    subId() {
      return this.$route.params.subId;
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.$ajax
        .get(findUserStatisticsByCreator2, {
          // createdBy: this.subId
          userId: this.subId,
        })
        .then((res) => {
          this.loading = false;
          this.userData = res?.data?.data || {};
        })
        .catch((err) => {
          this.loading = false;
          this.$message.info(`加载失败,${err.data}`);
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.users-detail-order {
  ul,
  li {
    list-style: none;
  }
  .order-form {
    margin-bottom: 16px;
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
    min-height: 620px;
  }
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-label {
      height: 20px;
      font-size: 12px;
      font-weight: 500;
      color: #8998a0;
      line-height: 20px;
      width: 85px;
      margin-right: 6px;
    }
    &-content {
      font-size: 14px;
      font-weight: 400;
      color: #040b28;
      line-height: 20px;
      .icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }
      .action {
        color: #005bff;
        font-size: 14px;
        cursor: pointer;
        margin-left: 16px;
      }
    }
  }
}
</style>
